import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import { NormalStockPriceI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import StockPutInPrefab from "./StockPutInPrefab ";

const { ccclass, property } = cc._decorator;

@ccclass
export default class StockBankruptcyPrefab extends cc.Component {
    @property(cc.Label)
    stockName: cc.Label = null

    @property(cc.Node)
    centerNode: cc.Node = null

    bindData(name: String) {
        this.stockName.string = `【${name}】`
    }

    onVideoBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(() => {
            O1HD.getServices().userSrv.setCoins(Math.floor(Math.floor(Math.random() * 30000 + 5000)), true, this.node)
            this.onCloseBtn()
        }, () => {
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败", this.node);
        }, () => {
        }, "破产减少损失");
    }

    onCloseBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        cc.tween(this.centerNode).to(.5, { scale: 0 }, { easing: cc.easing.backIn }).call(() => {
            this.node.destroy();
        }).start();
    }

}
